import { createFileRoute, redirect } from '@tanstack/react-router';
import { ListAnalytesSearch } from '../list-analytes';

export const Route = createFileRoute('/_authenticated/_navbar/analyte/')({
  beforeLoad: () => {
    throw redirect({ to: '/list-analytes', search: {} as ListAnalytesSearch });
  },
});
